/* istanbul ignore file */
import React from 'react';
import { Text } from '@amzn/atoz-web';
export var ShiftOpportunityDatePicker = function () { return (React.createElement(Text, null, "Placeholder ShiftOpportunityDatePicker")); };
